// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"ab68a855","168":"699b9324","268":"c4089ab6","526":"0aa46ddb","591":"8ec9c24e","665":"9dc813b7","681":"a0bf19b3","747":"5f96be7b","791":"1a659463","918":"3ae1df79","961":"56030571"}[chunkId] + ".chunk.js";
};